module.exports = __webpack_public_path__ + "media/images/pencil-3c74e0078f243e44b5c0191881c2ffd0.svg";